import { Pipe, PipeTransform } from '@angular/core';
import { BRAND_NAMES, BrandCode } from '../../constants/brand-names';

/**
 * Renders an app/platform code as its Mobeyond brand name — `{{ code | brandName }}`.
 *
 * Input is a plain `string` rather than `BrandCode` on purpose: some sinks pass a free-string
 * platform code straight from the backend, which we don't control. An unmapped code therefore
 * falls back to the raw code — never blank, never a throw, so a missing mapping degrades visibly
 * instead of hiding.
 *
 */
@Pipe({ name: 'brandName' })
export class BrandNamePipe implements PipeTransform {
  public transform(code: string): string {
    return BRAND_NAMES[code as BrandCode] ?? code;
  }
}
